__turbopack_context__.v({
  "gridItem": "GridItem-module-scss-module__CA4rza__gridItem",
  "imageWrapper": "GridItem-module-scss-module__CA4rza__imageWrapper",
  "text": "GridItem-module-scss-module__CA4rza__text",
  "title": "GridItem-module-scss-module__CA4rza__title",
});
